import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import notifications from '../../redux/notifications/actions';
import { executeAction } from '../../helpers/api';
import { sendRequest } from '../../helpers/saga';
import { logger } from '../../helpers/logger';

function* signIn({ payload }) {
  try {
    const { url, method, data } = payload;

    const result = yield call(sendRequest, executeAction, { url, method, data }, notifications.REQUEST_ERROR);

    if (result?.status === 200) {
      yield put(actions.signInSuccess(result));
    } else {
      yield put(actions.signInFail(result));
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.SIGN_IN_REQUEST, signIn)]);
}
